const jsonSchema = [
  {
    name: 'rank',
    label: 'Rank',
    type: 'number',
    required: true,
    showInList: true,
  },
  {
    name: 'name',
    label: 'Name',
    type: 'text',
    showInList: true,
  },  
  {
    name: 'score',
    label: 'Score',
    type: 'number',
    showInList: true,
  }

  // Add more fields as needed
];
export default jsonSchema;
